import * as React from "react";

export const BrainIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.333"
      d="M14 21V5.833M17.5 15.167A4.865 4.865 0 0 1 14 10.5a4.865 4.865 0 0 1-3.5 4.667M20.531 7.583A3.499 3.499 0 1 0 14 5.833a3.5 3.5 0 1 0-6.531 1.75"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.333"
      d="M20.996 5.98a4.666 4.666 0 0 1 2.947 6.73"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.333"
      d="M21 21a4.667 4.667 0 0 0 2.333-8.708"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.333"
      d="M23.295 20.397a4.668 4.668 0 0 1-7.817 4.005A4.67 4.67 0 0 1 14 21a4.667 4.667 0 1 1-9.295-.603"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.333"
      d="M7 21a4.667 4.667 0 0 1-2.333-8.708"
    ></path>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.333"
      d="M7.004 5.98a4.667 4.667 0 0 0-2.947 6.73"
    ></path>
  </svg>
);
